<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

<h5>古籍</h5>

古今中外，有關易經的書籍非常多。在【XiYi 習易網】裡，目前我只放了最基本的周易、十翼原始經文和朱熹的卦序歌，主要是為了快速查找、建立整體卦象與關聯。您平時喜歡讀哪些易經書籍，還請繼續閱讀。【XiYi 習易網】只是一個習易的工具，並不能取代您的藏書，也不能教您【易】或是【易經】。

至於標點符號，我大致是以臺大出版中心印行的「周易王韓註」為主、以及臺大出版中心印行的「朱熹周易本義」為輔。
如果和您用的不一樣，就麻煩您參照您的文本，有空的話，也煩請<a href="mailto:ixiyi88@gmail.com">來信（email）</a>指教，我會不斷地校正內容。

{:else }

<h5>古籍</h5>

古今中外，有关易经的书籍非常多。在【XiYi 习易网】里，目前我只放了最基本的周易、十翼原始经文和朱熹的卦序歌，主要是为了快速查找、建立整体卦象与关联。您平时喜欢读哪些易经书籍，还请继续阅读。【XiYi 习易网】只是一个习易的工具，并不能取代您的藏书，也不能教您【易】或是【易经】。

至于标点符号，我大致是以台大出版中心印行的「周易王韩注」为主、以及台大出版中心印行的「朱熹周易本义」为辅。
如果和您用的不一样，就麻烦您参照您的文本，有空的话，也烦请<a href="mailto:ixiyi88@gmail.com">来信（email）</a>指教，我会不断地校正内容。

{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
</style>
